import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-32')!;

export default function Frame32() {
  return <SecureResidenceSubFrame panel={panel} />;
}
